
define('tpl!taoQtiItem/qtiCreator/tpl/interactions/matchInteraction.cell', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<td>\n    <label>\n        <input type=\"checkbox\" >\n        <span class=\"icon-checkbox cross\"></span>\n    </label>\n</td>";
  });
});

